export default "__VITE_ASSET__CLaS8qTc__"